import React, { Suspense } from 'react';
import { ErrorScreenDebug } from '../Error/ErrorScreenDebug';
import { Dialog } from '../shared/dialog/Dialog';
import { Loading } from '../shared/Loading';
import { DialogRoute } from '../shared/routes/DialogRoute';
import { ScreenSwapRoute } from '../shared/routes/ScreenSwapRoute';
import { Credit } from './Credit';
import { LanguageSelect } from './LanguageSelect';
import { License } from './License';
import { PlayerSwitch } from './PlayerSwitch';
import { SettingsList } from './SettingList/SettingsList';

const FakeDateForm = React.lazy(() => import('./debug/FakeDateForm'));
const FontCheck = React.lazy(() => import('./FontCheck'));

const Settings: React.FC = () => {
  return (
    <>
      <ScreenSwapRoute path="/players/settings">
        <SettingsList />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/settings/switch-user">
        <PlayerSwitch />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/settings/language">
        <LanguageSelect />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/settings/license">
        <License />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/settings/credit">
        <Credit />
      </ScreenSwapRoute>

      {/* debug menus */}
      <ScreenSwapRoute path="/players/settings/font-check">
        <FontCheckComponent />
      </ScreenSwapRoute>
      <ScreenSwapRoute path="/players/settings/server-error">
        <ErrorScreenDebugComponent />
      </ScreenSwapRoute>
      <DialogRoute path="/players/settings/fake-date">
        <Dialog hasHeader={true}>
          <FakeDateFormComponent />
        </Dialog>
      </DialogRoute>
    </>
  );
};

export default Settings;

function FontCheckComponent() {
  if (process.env.REACT_APP_DEBUG_OPTION === 'true') {
    return (
      <Suspense fallback={<Loading />}>
        <FontCheck />
      </Suspense>
    );
  } else {
    return <></>;
  }
}

function ErrorScreenDebugComponent() {
  if (process.env.REACT_APP_DEBUG_OPTION === 'true') {
    return (
      <Suspense fallback={<Loading />}>
        <ErrorScreenDebug />
      </Suspense>
    );
  } else {
    return <></>;
  }
}

function FakeDateFormComponent() {
  if (process.env.REACT_APP_DEBUG_OPTION === 'true') {
    return (
      <Suspense fallback={<Loading />}>
        <FakeDateForm />
      </Suspense>
    );
  } else {
    return <></>;
  }
}
